import React, { useEffect, useState } from 'react';

import './Integrations.scss';
import { useSelector } from 'react-redux';
import { Button, Divider, Form, Select, Spin, Switch, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';

import { doCreateSetting, doGetSettings, doUpdateSetting } from '../../../modules/settings/store/thunk';
import { clearState, selectAllSettings } from '../../../modules/settings/store/slice';

import { useForm } from 'antd/es/form/Form';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import { doGetLocations } from '../../../modules/locations/stores/thunk';

export const ShippingRules = () => {
  const dispatch = useDispatch();
  const [form] = useForm();

  const locations = useSelector((state) => state.auth.user.locations);
  const [isFetching, setIsFetching] = useState(false);
  const [location, setLocation] = useState(null);

  const locationOptions = locations.map((l) => ({ label: l.name, value: l.id }));

  const settingTypes = [{ value: 'USE_AREAS_BY_PRIORITY', label: 'Use areas by priority' }];
  const settingKeys = settingTypes.map((type) => type.value);

  // Settings
  const settings = useSelector((state) => selectAllSettings(state));

  useEffect(() => {
    dispatch(clearState());
    dispatch(doGetLocations({ page: 1, take: 1000 }));
  }, []);

  // Fetch the settings
  useEffect(() => {
    setIsFetching(true);
    if (location) {
      dispatch(
        doGetSettings({
          category: 'shipping-rules',

          locationId: location.id,
        }),
      );
    }
    setIsFetching(false);
    return () => dispatch(clearState()); // explicitly clear the state to prevent it from being used in different component
  }, [location]);

  useEffect(() => {
    const s = settings.find((s) => s.keyword === 'USE_AREAS_BY_PRIORITY');
    console.log({ s });
    if (s) {
      form.setFieldValue('USE_AREAS_BY_PRIORITY', s.value === 'true');
    }
  }, [settings]);

  const onFinish = async (values) => {
    setIsFetching(true);
    const l = locations.find((l) => l.locationId === location.locationId);
    if (!l) return;
    const updates = settingKeys.map((k) => ({
      id: settings.find((e) => e.keyword === k)?.id || undefined,
      keyword: k,
      value: values[k] ? 'true' : 'false',
      group: 'SHIPPING_RULES',
      locationId: l.id,
      companyId: l.companyId,
    }));

    // send updates or creates to backend depending on their existance
    await Promise.all(
      updates.map(async (u) => {
        if (u.id && u.value) {
          // if it existed and has a value => update it
          await dispatch(doUpdateSetting(u));
        } else if (u.value) {
          // if it didn't exist => create it
          await dispatch(doCreateSetting(u));
        }
      }),
    );
    setIsFetching(false);
  };

  return (
    <div className="info">
      <div className="info-content">
        <h3>Shipping Rules</h3>
        <h5>Configure the shipping rules for your locations</h5>
      </div>
      <div>
        <h4>
          1. Select your location
          <Tooltip title="Select the location that you want your shopify store to create orders for">
            <QuestionCircleTwoTone style={{ marginLeft: 8 }} />
          </Tooltip>
        </h4>

        <Select
          className="select-small"
          options={locationOptions}
          onSelect={(id) => setLocation(locations.find((l) => l.id === id))}
          style={{ minWidth: '200px' }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}></div>
      {location && (
        <div>
          <Divider />
          <Spin spinning={isFetching}>
            <Form form={form} scrollToFirstError onFinish={onFinish} layout="vertical">
              <h4>Retry if preferred carrier cannot deliver</h4>
              <Form.Item
                label="Try to register package with next prioritized carrier if first fails"
                name="USE_AREAS_BY_PRIORITY"
              >
                <Switch />
              </Form.Item>

              <Button type="primary" size="small" htmlType="submit" loading={isFetching}>
                Save settings
              </Button>
            </Form>
          </Spin>
        </div>
      )}
    </div>
  );
};
